import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 默认关闭
      dialogVisible: false,
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        areaCode: null, // 行政区域代码
        areaName: null, // 行政区域名称
        parentAreaCode: null, // 上级行政区分代码
        parentAreaName: null, // 上级行政区域名称
        levelNum: null, // 行政级别
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "行政区域代码：",
          value: "areaCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "行政区域名称：",
          value: "areaName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "上级行政区域：",
          value: "parentAreaName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "行政级别：",
          value: "levelNum",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201507041522510003"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "上级行政区域",
          prop: "parentAreaName",
        },
        {
          label: "行政区域名称",
          slotName: "areaName",
        },
        {
          label: "行政级别",
          prop: "levelName",
        },
        {
          label: "操作",
          slotName: "operation",
        }
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      // 合并单元格的长度
      rowSpanArr: null,
    };
  },
  // 接收来自父组件的数据
  props: {
    // 上级行政区域代码
    parentAreaCode: {
      type: String
    },
    // 行政级别
    levelNum: {
      type: String
    },
  },
  // 注册组件
  components: {},
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 传递参数上级行政区域代码不为空
      if(this.parentAreaCode != '' && this.parentAreaCode != null){
        // 上级行政区域赋值
        this.form.parentAreaCode = this.parentAreaCode;
        // 遍历查询表单
        this.formSearchList.forEach(e =>{
          // 如果是上级行政区域名称
          if(e.value === "parentAreaName"){
            e.disabled = true; // 置灰
          }
        });
      }
      // 传递参数行政级别不为空
      if(this.levelNum != '' && this.levelNum != null){
        // 行政级别赋值
        this.form.levelNum = this.levelNum;
        // 遍历查询表单
        this.formSearchList.forEach(e =>{
          // 如果是行政级别
          if(e.value === "levelNum"){
            e.disabled = true; // 置灰
          }
        });
      }
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/administrativeArea/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
          // 传递参数行政级别为空
          if(this.levelNum == '' || this.levelNum == null){
            // 获取需要合并单元格
            this.handleTableData();
          }
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框点击事件
     */
    fun_GetSelectVal(e, i) {
      // 行政级别
      if (i === "levelNum") {
        // 赋值
        this.form.levelNum = e;
      }
    },
    // 获取相同名称的个数 parentAreaName: 确定相同的参数
    handleTableData(){
      let rowSpanArr = [], position = 0;
      for (let [index, item] of this.tableData.entries()) {
        if (index == 0) {
          rowSpanArr.push(1);
          position = 0;
        } else {
          if (item.parentAreaName == this.tableData[index - 1].parentAreaName) {
            rowSpanArr[position] += 1; //项目名称相同，合并到同一个数组中
            rowSpanArr.push(0);
          } else {
            rowSpanArr.push(1);
            position = index;
          }
        }
      }
      this.rowSpanArr = rowSpanArr
    },
    /**
     * 单元格合并方法
     */
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const rowSpan = this.rowSpanArr[rowIndex];
        return {
          rowspan: rowSpan,
          colspan: 1
        };
      }
    },
    /**
     * 行政区划选择赋值
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_SetAdministrativeArea(e) {
      console.log(e)
      // 回调函数
      // this.$nextTick(() => {
        // 赋值父页面上级行政区分代码
        this.$parent.form.parentAreaCode = e.areaCode;
        // 赋值父页面上级行政区域名称
        this.$parent.form.parentAreaName = e.areaName;
        // 赋值父页面行政区域名称
        this.$parent.form.areaCode = e.areaCode;
        // 关闭页面弹框
        this.dialogVisible = false;
      // });
    },
  }
};
